import { Routes } from '@angular/router';
import { AuthLoginPageComponent } from './features/auth/pages/auth-login-page/auth-login-page.component';
import { AuthVerifyOtpPageComponent } from './features/auth/pages/auth-verify-otp-page/auth-verify-otp-page.component';
import { GlobalStartScreenPageComponent } from './global/pages/global-start-screen-page/global-start-screen-page.component';
import { GlobalStartNewsTabComponent } from './global/pages/global-start-news-tab/global-start-news-tab.component';
import { GlobalStartUeberUnsTabComponent } from './global/pages/global-start-ueber-uns-tab/global-start-ueber-uns-tab.component';
import { GlobalStartMitarbeiterTabComponent } from './global/pages/global-start-mitarbeiter-tab/global-start-mitarbeiter-tab.component';
import { GeruestanfragePageComponent } from './features/geruestanfrage/pages/geruestanfrage-page/geruestanfrage-page.component';
import { MitarbeitendeHomePageComponent } from './features/mitarbeitende/pages/mitarbeitende-home-page/mitarbeitende-home-page.component';
import { MitarbeitendeMenuPageComponent } from './features/mitarbeitende/pages/mitarbeitende-menu-page/mitarbeitende-menu-page.component';
import { AdressbuchListPageComponent } from './features/adressbuch/pages/addressbuch-list-page/adressbuch-list-page.component';
import { AdressbuchMitarbeitendeDetailsPageComponent } from './features/adressbuch/pages/addressbuch-mitarbeitende-details-page/adressbuch-mitarbeitende-details-page.component';
import { AdressbuchMitarbeitendePersonaldossierPageComponent } from './features/adressbuch/pages/adressbuch-mitarbeitende-personaldossier-page/adressbuch-mitarbeitende-personaldossier-page.component';
import { MitteilungenListPageComponent } from './features/mitteilungen/pages/mitteilungen-list-page/mitteilungen-list-page.component';
import { MitteilungenDetailsPageComponent } from './features/mitteilungen/pages/mitteilungen-details-page/mitteilungen-details-page.component';
import { ProjekteDetailsPageComponent } from './features/projekte/pages/projekte-details-page/projekte-details-page.component';
import { ProjekteDetailsErstinstruktionPageComponent } from './features/projekte/pages/projekte-details-erstinstruktion-page/projekte-details-erstinstruktion-page.component';
import { ProjekteDetailsAbschlussprotokollPageComponent } from './features/projekte/pages/projekte-details-abschlussprotokoll-page/projekte-details-abschlussprotokoll-page.component';
import { ProjekteUebersichtPageComponent } from './features/projekte/pages/projekte-uebersicht-page/projekte-uebersicht-page.component';
import { ArbeitszeitUebersichtPageComponent } from './features/arbeitszeit/pages/arbeitszeit-uebersicht-page/arbeitszeit-uebersicht-page.component';
import { IsEmployeeGuard, IsLoggedInGuard, RedirectToDashboardIfIsLoggedInGuard } from '@work-frontend-monorepo/work-authentication';
import { ProjekteDetailsDokumentePageComponent } from './features/projekte/pages/projekte-details-dokumente-page/projekte-details-dokumente-page.component';
import { ProjekteDetailsFotosPageComponent } from './features/projekte/pages/projekte-details-fotos-page/projekte-details-fotos-page.component';
import { ProjekteDetailsSchadenMeldenPageComponent } from './features/projekte/pages/projekte-details-schaden-melden-page/projekte-details-schaden-melden-page.component';
import { AuthLogoutPageComponent } from './features/auth/pages/auth-logout-page/auth-logout-page.component';
import { GlobalAppStartingScreenPageComponent } from './global/pages/global-app-starting-screen-page/global-app-starting-screen-page.component';
import { ScanUndUploadPageComponent } from './features/scan-und-upload/pages/scan-und-upload-page/scan-und-upload-page.component';
import { AbsenzenUebersichtPageComponent } from './features/absenzen/pages/absenzen-uebersicht-page/absenzen-uebersicht-page.component';
import { MontageplanUebersichtPageComponent } from './features/montageplan/pages/montageplan-uebersicht-page/montageplan-uebersicht-page.component';
import { AkquiseListePageComponent } from './features/akquise/pages/akquise-liste-page/akquise-liste-page.component';
import { AkquiseErfassenPageComponent } from './features/akquise/pages/akquise-erfassen-page/akquise-erfassen-page.component';
import { AkquiseDetailsPageComponent } from './features/akquise/pages/akquise-details-page/akquise-details-page.component';

export const appRoutes: Routes = [
  {
    path: '',
    component: GlobalAppStartingScreenPageComponent,
  },
  {
    path: 'start',
    component: GlobalStartScreenPageComponent,
    children: [
      {
        path: '',
        redirectTo: 'geruestanfrage',
        pathMatch: 'full',
      },
      {
        path: 'geruestanfrage',
        component: GeruestanfragePageComponent,
      },
      {
        path: 'news',
        component: GlobalStartNewsTabComponent,
      },
      {
        path: 'ueber-uns',
        component: GlobalStartUeberUnsTabComponent,
      },
      {
        path: 'mitarbeiter',
        component: GlobalStartMitarbeiterTabComponent,
      },
    ],
  },
  {
    path: 'dashboard', // Required redirect for 'RedirectToDashboardIfIsLoggedInGuard'
    redirectTo: 'mitarbeitende',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        canActivate: [RedirectToDashboardIfIsLoggedInGuard],
        component: AuthLoginPageComponent,
      },
      {
        path: 'logout',
        component: AuthLogoutPageComponent,
      },
      {
        path: 'verify-otp',
        canActivate: [RedirectToDashboardIfIsLoggedInGuard],
        component: AuthVerifyOtpPageComponent,
      },
    ],
  },
  {
    path: 'mitarbeitende',
    canActivate: [IsLoggedInGuard, IsEmployeeGuard],
    children: [
      {
        path: '',
        component: MitarbeitendeMenuPageComponent,
        children: [
          {
            path: '',
            redirectTo: 'home',
            pathMatch: 'full',
          },
          {
            path: 'home',
            component: MitarbeitendeHomePageComponent,
          },
          {
            path: 'mitteilungen',
            children: [
              {
                path: '',
                redirectTo: 'liste',
                pathMatch: 'full',
              },
              {
                path: 'liste',
                component: MitteilungenListPageComponent,
              },
              {
                path: 'details/:newsId',
                component: MitteilungenDetailsPageComponent,
              },
            ],
          },
          {
            path: 'arbeitszeit',
            children: [
              {
                path: '',
                redirectTo: 'uebersicht',
                pathMatch: 'full',
              },
              {
                path: 'uebersicht',
                component: ArbeitszeitUebersichtPageComponent,
              },
            ],
          },
          {
            path: 'projekte',
            children: [
              {
                path: '',
                redirectTo: 'uebersicht',
                pathMatch: 'full',
              },
              {
                path: 'uebersicht',
                component: ProjekteUebersichtPageComponent,
              },
              {
                path: 'details/:projectId',
                children: [
                  {
                    path: '',
                    component: ProjekteDetailsPageComponent,
                  },
                  {
                    path: 'erstinstruktion',
                    component: ProjekteDetailsErstinstruktionPageComponent,
                  },
                  {
                    path: 'abschlussprotokoll',
                    component: ProjekteDetailsAbschlussprotokollPageComponent,
                  },
                  {
                    path: 'dokumente',
                    component: ProjekteDetailsDokumentePageComponent,
                  },
                  {
                    path: 'fotos',
                    component: ProjekteDetailsFotosPageComponent,
                  },
                  {
                    path: 'schaden-melden',
                    component: ProjekteDetailsSchadenMeldenPageComponent,
                  },
                ],
              },
            ],
          },
          {
            path: 'adressbuch',
            children: [
              {
                path: '',
                redirectTo: 'liste',
                pathMatch: 'full',
              },
              {
                path: 'liste',
                component: AdressbuchListPageComponent,
              },
              {
                path: 'details/:userId',
                component: AdressbuchMitarbeitendeDetailsPageComponent,
              },
              {
                path: 'details/:userId/personaldossier',
                component: AdressbuchMitarbeitendePersonaldossierPageComponent,
              },
            ],
          },
          {
            path: 'absenzen',
            children: [
              {
                path: '',
                redirectTo: 'uebersicht',
                pathMatch: 'full',
              },
              {
                path: 'uebersicht',
                component: AbsenzenUebersichtPageComponent,
              },
            ],
          },
          {
            path: 'scan-und-upload',
            component: ScanUndUploadPageComponent,
          },
          {
            path: 'montageplan',
            component: MontageplanUebersichtPageComponent,
          },
          {
            path: 'akquise',
            children: [
              {
                path: '',
                redirectTo: 'liste',
                pathMatch: 'full',
              },
              {
                path: 'liste',
                component: AkquiseListePageComponent,
              },
              {
                path: 'neu',
                component: AkquiseErfassenPageComponent,
              },
              {
                path: 'details/:prospectId',
                children: [
                  {
                    path: '',
                    component: AkquiseDetailsPageComponent,
                  },
                  {
                    path: 'bearbeiten',
                    component: AkquiseErfassenPageComponent,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];